import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Hammer, Plus } from 'lucide-react';
import { StatusBadge } from './StatusBadge';
import { api, dateRange, moneyShort } from '../../utils/upgradesApi';

// Card in the machine detail: upgrades done / planned for this serial number, and a shortcut to start a new one.
const MachineUpgradesCard = ({ machineId, serialNumber }) => {
  const navigate = useNavigate();
  const [jobs, setJobs] = useState(null);

  useEffect(() => {
    let cancelled = false;
    api(`/?machine_id=${machineId}`).then((data) => { if (!cancelled) setJobs(data); }).catch(() => { if (!cancelled) setJobs([]); });
    return () => { cancelled = true; };
  }, [machineId]);

  return (
    <div style={{ backgroundColor: '#FAFAFA', border: '1px solid #EEE', borderRadius: '8px', padding: '12px 14px', marginBottom: '20px' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
        <Hammer size={16} color="#E53935" aria-hidden="true" />
        <strong style={{ fontSize: 14, color: '#333' }}>Úpravy u zákazníka</strong>
        <button type="button" onClick={() => navigate(`/upravy?new=${encodeURIComponent(serialNumber)}`)}
          style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: 6, padding: '6px 12px', borderRadius: 8, border: '1px solid #E0E0E0', background: '#FFF', cursor: 'pointer', fontSize: 13, fontWeight: 600 }}>
          <Plus size={14} /> Nová úprava
        </button>
      </div>
      {jobs && jobs.length === 0 && <p style={{ margin: '8px 0 0', fontSize: 13, color: '#999' }}>Žádná úprava tohoto trenažéru.</p>}
      {jobs && jobs.length > 0 && (
        <div style={{ display: 'grid', gap: 6, marginTop: 10 }}>
          {jobs.map((j) => (
            <Link key={j.id} to={`/upravy/${j.id}`} className="upg-mini" style={{ background: '#FFF' }}>
              <span style={{ minWidth: 0 }}>
                <strong style={{ fontSize: 13 }}>{j.number}</strong> <span style={{ fontSize: 13 }}>{j.title}</span>
                <span style={{ display: 'block', fontSize: 12, color: '#777' }}>{dateRange(j)} · {moneyShort(j.totals.gross)}</span>
              </span>
              <StatusBadge status={j.status} />
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default MachineUpgradesCard;
